var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { injectable, inject } from 'inversify';
import { TYPES } from '@/dependency-injection/types';
import { BaseManagementService } from '@/services/base-management-service';
import { CarrierService } from '@/services/carrier-management/carrier-service';
import { EncryptionService } from '../encryption-service';
var UserService = /** @class */ (function (_super) {
    __extends(UserService, _super);
    function UserService(carrierService) {
        var _this = _super.call(this, '/api/v1/management/user') || this;
        _this.carrierType = 'carrier';
        _this.internalType = 'internal';
        _this.rslType = 'rsl';
        _this.locoType = 'loco';
        _this.carrierTypeShort = 'E';
        _this.internalTypeShort = 'I';
        _this.carrierService = carrierService;
        return _this;
    }
    UserService.prototype.getAllUsers = function (includeDeleted) {
        if (includeDeleted === void 0) { includeDeleted = false; }
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getall';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                IncludeDeleted: includeDeleted,
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Unable to get users");
                        console.error(error_1);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.getDefault = function () {
        return {};
    };
    UserService.prototype.getUserById = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getbyid';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { UserId: id })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            data = response.data;
                            // flatten the carriers collection for UI tree view
                            data.carriers = this.carrierService.flattenCarriersCollection({
                                desks: data.carrierIds,
                                carriers: data.carrierParentIds,
                                groups: data.carrierGroupIds,
                            });
                            return [2 /*return*/, data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error("Unable to get user");
                        console.error(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // If the user is in WAM, returns a User_AnyApplication object.
    // If the user is not in WAM, returns null.
    // If there's an error, throws an error.
    UserService.prototype.getUserById_AnyApplication = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, data, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getbyidanyapplication';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { UserId: EncryptionService.encryptUserId(id) })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 204) {
                            return [2 /*return*/, null];
                        }
                        if (response.status === 200) {
                            data = response.data;
                            return [2 /*return*/, data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error("Unable to get user");
                        console.error(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.isExistingUser = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/isexistinguser';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { UserId: id })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.error("Unable to check to see if is an existing user");
                        console.error(error_4);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.isExistingEmail = function (email) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/isexistingemail';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { Email: email })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        console.error("Unable to check to see if email is in use");
                        console.error(error_5);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.save = function (user, isExistingUser) {
        if (isExistingUser === void 0) { isExistingUser = true; }
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, data, carriers, i, len, response, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = isExistingUser ? '/update' : '/create';
                        data = __assign({}, user);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // take the flat collection of carriers from TreeView and un-flatten in to collections
                        if (data.userType === this.carrierType) {
                            carriers = this.carrierService.unFlattenCarriersCollection(data.carriers);
                            data.carrierIds = carriers.desks;
                            data.carrierParentIds = carriers.carriers;
                            data.carrierGroupIds = carriers.groups;
                        }
                        else {
                            // remove any data set for non carrier users
                            data.carrierIds = [];
                            data.carrierParentIds = [];
                            data.carrierGroupIds = [];
                        }
                        for (i = 0, len = data.filters.length; i < len; i++) {
                            if (data.filters[i].userId.length === 0) {
                                data.filters[i].userId = data.userId;
                            }
                        }
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                UserId: data.userId,
                                Email: data.email,
                                DisableEmailNotifications: data.disableEmailNotifications,
                                FirstName: data.firstName,
                                LastName: data.lastName,
                                OfficePhone: data.officePhone,
                                CellPhone: data.cellPhone,
                                UserType: data.userType === this.internalType ? this.internalTypeShort : this.carrierTypeShort,
                                Role: data.userSubType,
                                Rsl: data.rsl,
                                VoyageLoadList: data.reportFilters.voyageLoadList,
                                Filters: data.filters,
                                Notes: data.notes,
                                CarrierIds: data.carrierIds,
                                CarrierParentIds: data.carrierParentIds,
                                CarrierGroupIds: data.carrierGroupIds,
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        console.error("Unable to save user");
                        console.error(error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, response, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/delete';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { UserId: id })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, true];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_7 = _a.sent();
                        console.error("Unable to delete user");
                        console.error(error_7);
                        throw error_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.selectedUserIsRslWithLocos = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var associatedLocos;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(user.userSubType.toLowerCase() === this.rslType.toLowerCase())) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getLocos(user.userId)];
                    case 1:
                        associatedLocos = _a.sent();
                        return [2 /*return*/, associatedLocos.length > 0];
                    case 2: return [2 /*return*/, false];
                }
            });
        });
    };
    UserService.prototype.canDeleteUser = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, response, responseMessage, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/candeleteuser';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { UserId: user.userId })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_8 = _a.sent();
                        console.error("Unable to check if user can be deleted");
                        console.error(error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.restore = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, response, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/restore';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { UserId: user.userId, Email: user.email })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, true];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_9 = _a.sent();
                        console.error("Unable to restore user");
                        console.error(error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.getValidationRules = function () {
        return {
            userId: {
                required: true,
                max: 15,
                regex: '^([a-zA-Z0-9._-]+)$',
                isExistingUser: true,
            },
            firstName: {
                required: true,
                max: 50,
            },
            lastName: {
                required: true,
                max: 50,
            },
            email: {
                required: true,
                email: true,
                max: 100,
                isExistingEmail: true,
            },
            officePhone: {
                max: 14,
                phoneNumber: true,
            },
            officePhoneExtension: {
                max: 5,
                regex: '^([0-9#\*]{0,5})$',
            },
            cellPhone: {
                max: 14,
                phoneNumber: true,
            },
            note: {
                max: 500,
            },
            userType: {
                required: true,
            },
            userSubType: {
                required: true,
                is_not: '00000000-0000-0000-0000-000000000000',
            },
            rsls: {
                required: true,
            },
            statuses: {
                required: true,
            },
        };
    };
    UserService.prototype.getRsls = function () {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getrsls';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint)];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_10 = _a.sent();
                        console.error("Unable to get RSLs");
                        console.error(error_10);
                        throw error_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.getLocos = function (userId) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getlocosforrsl';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { UserId: userId })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_11 = _a.sent();
                        console.error("Unable to get LOCOs");
                        console.error(error_11);
                        throw error_11;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(UserService.prototype, "canEditUsers", {
        get: function () {
            return this.authService.isAuthorized('USERMGMT', 'WRITE');
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    UserService = __decorate([
        injectable(),
        __param(0, inject(TYPES.CarrierService)),
        __metadata("design:paramtypes", [typeof (_a = typeof CarrierService !== "undefined" && CarrierService) === "function" ? _a : Object])
    ], UserService);
    return UserService;
}(BaseManagementService));
export { UserService };
